// Merchless redesign — small JS for scroll-driven micro-interactions.
//
// Currently does:
//   - Toggles `.is-scrolled` on the body once the user has scrolled past
//     a threshold. CSS uses this to shrink the sticky header, reduce its
//     padding, and tighten the logo.
//
// Keeps the file tiny and dependency-free — no jQuery, no animation
// libraries. Just requestAnimationFrame-throttled scroll listener.

(function () {
  'use strict';

  const SCROLL_THRESHOLD = 60;
  const body = document.body;
  let lastScrolled = null;
  let ticking = false;

  function update() {
    const scrolled = window.scrollY > SCROLL_THRESHOLD;
    if (scrolled !== lastScrolled) {
      body.classList.toggle('is-scrolled', scrolled);
      lastScrolled = scrolled;
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  // Initialize on load (in case page loads scrolled, e.g. anchor link).
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
